import {
  Underline
} from "./chunk-KA7SO5SJ.js";

// src/components/AgentReferral/InfoCard/InfoCard.tsx
import { circleInfo } from "@simplybusiness/icons";
import { Flex, Icon } from "@simplybusiness/mobius";
import classNames from "classnames/dedupe";
import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
var InfoCard = forwardRef((props, ref) => {
  const { header, children, className, ...otherProps } = props;
  const classes = classNames("mobius", "mobius-info-card", className, {
    "--has-header": header
  });
  const headerClasses = "mobius-info-card__header";
  const iconClasses = "mobius-info-card__icon";
  const contentClasses = "mobius-info-card__content";
  return /* @__PURE__ */ jsxs(
    Flex,
    {
      flexGrow: 1,
      ref,
      role: "note",
      className: classes,
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx("span", { className: iconClasses, children: /* @__PURE__ */ jsx(Icon, { icon: circleInfo, size: "sm", title: "Important information" }) }),
        /* @__PURE__ */ jsxs("div", { children: [
          header && /* @__PURE__ */ jsx("p", { className: headerClasses, children: header }),
          /* @__PURE__ */ jsx("div", { className: contentClasses, children })
        ] })
      ]
    }
  );
});
InfoCard.displayName = "InfoCard";

// src/components/AgentReferral/AgentReferral.tsx
import classNames2 from "classnames/dedupe";
import { forwardRef as forwardRef2 } from "react";

// src/components/AgentReferral/AgentReferralReasons.tsx
import { Text } from "@simplybusiness/mobius";
import { jsx as jsx2, jsxs as jsxs2 } from "react/jsx-runtime";
var AgentReferralReasons = (props) => {
  const { firstName, referralReasons } = props;
  return /* @__PURE__ */ jsxs2("div", { className: "mobius-agent-referral__reasons", children: [
    /* @__PURE__ */ jsxs2(Text, { variant: "h3", children: [
      "Sorry! Here are some key factors why we couldn't get any quotes for",
      " ",
      firstName
    ] }),
    referralReasons.map(({ title, description }) => /* @__PURE__ */ jsx2(InfoCard, { header: title, children: description }, title))
  ] });
};

// src/components/AgentReferral/AgentReferralText.tsx
import { Text as Text2 } from "@simplybusiness/mobius";
import { jsx as jsx3, jsxs as jsxs3 } from "react/jsx-runtime";
var AgentReferralText = (props) => {
  const { firstName, referenceNumber, phoneNumber } = props;
  return /* @__PURE__ */ jsxs3("div", { className: "mobius-agent-referral__text", children: [
    /* @__PURE__ */ jsxs3(Text2, { elementType: "h2", children: [
      "Thanks, ",
      firstName
    ] }),
    /* @__PURE__ */ jsx3(Text2, { variant: "body", children: "We're sorry, but we can't offer a quote based on the answers you provided." }),
    /* @__PURE__ */ jsxs3(Text2, { variant: "body", children: [
      "We'd be happy to explain further. Feel free to talk with one of our agents at ",
      /* @__PURE__ */ jsx3("strong", { children: phoneNumber }),
      ". Please keep this reference number ",
      /* @__PURE__ */ jsx3("strong", { children: referenceNumber }),
      " handy when you call."
    ] }),
    /* @__PURE__ */ jsx3(Text2, { elementType: "h3", children: "Did you know?" }),
    /* @__PURE__ */ jsx3(Text2, { variant: "body", children: "Among the trades agents quote the most with us include painting and wall covering, handyperson, and carpentry, each covering up to $1 million per occurrence." })
  ] });
};

// src/components/AgentReferral/AgentReferral.tsx
import { jsx as jsx4 } from "react/jsx-runtime";
var AgentReferral = forwardRef2(
  (props, ref) => {
    const { className, componentName, ...otherProps } = props;
    const { variant } = otherProps;
    const classes = classNames2("mobius", "mobius-agent-referral", className);
    return /* @__PURE__ */ jsx4(
      "div",
      {
        ref,
        ...componentName ? { "data-component": componentName } : {},
        ...variant ? { "data-variant": variant } : {},
        className: classes,
        children: variant === "referral-reasons" ? /* @__PURE__ */ jsx4(
          AgentReferralReasons,
          {
            ...otherProps
          }
        ) : /* @__PURE__ */ jsx4(AgentReferralText, { ...otherProps })
      }
    );
  }
);
AgentReferral.displayName = "AgentReferral";

// src/components/AgentResources/AgentResources.tsx
import { arrowDownToLine, link } from "@simplybusiness/icons";
import { Icon as Icon2, Link, LinkButton, Text as Text3 } from "@simplybusiness/mobius";
import { jsx as jsx5, jsxs as jsxs4 } from "react/jsx-runtime";
var AgentResources = (props) => {
  const {
    appetiteGuideUrl,
    workingWithUsUrl,
    newQuoteUrl,
    componentName,
    ...otherProps
  } = props;
  const { variant } = otherProps;
  return /* @__PURE__ */ jsxs4(
    "div",
    {
      className: "mobius-agent-resources",
      ...otherProps,
      ...componentName ? { "data-component": componentName } : {},
      ...variant ? { "data-variant": variant } : {},
      children: [
        /* @__PURE__ */ jsxs4(Text3, { elementType: "h3", className: "mobius-agent-resources__title", children: [
          "Agent Resources",
          /* @__PURE__ */ jsx5(Underline, { className: "mobius-agent-resources__title-underline" })
        ] }),
        /* @__PURE__ */ jsxs4("ul", { className: "mobius-agent-resources__list", children: [
          /* @__PURE__ */ jsxs4("li", { className: "mobius-agent-resources__list-item", children: [
            /* @__PURE__ */ jsx5(Icon2, { icon: arrowDownToLine, size: "md", title: "Download file" }),
            /* @__PURE__ */ jsx5(Link, { href: appetiteGuideUrl, target: "_blank", children: "Download Appetite Guide" })
          ] }),
          workingWithUsUrl && /* @__PURE__ */ jsxs4("li", { className: "mobius-agent-resources__list-item", children: [
            /* @__PURE__ */ jsx5(Icon2, { icon: link, size: "md", title: "External link" }),
            /* @__PURE__ */ jsx5(Link, { href: workingWithUsUrl, target: "_blank", children: "Working with Simply Business" })
          ] })
        ] }),
        newQuoteUrl && /* @__PURE__ */ jsx5(LinkButton, { href: newQuoteUrl, children: "Start New Quote" })
      ]
    }
  );
};

export {
  InfoCard,
  AgentReferral,
  AgentResources
};
